import { Loading } from '@actinc/dls/components/Loading';
import { CircularProgressProps } from '@mui/material/CircularProgress';
import React, { CSSProperties } from 'react';
export interface LoadingContentProps {
  circularProgressProps?: CircularProgressProps;
  style?: CSSProperties;
  title?: string;
}
export const LoadingContent: React.FC<LoadingContentProps> = ({
  circularProgressProps,
  style,
  title = 'loading...'
}: LoadingContentProps): React.ReactElement => <Loading title={title} {...circularProgressProps} style={style} data-sentry-element="Loading" data-sentry-component="LoadingContent" data-sentry-source-file="index.tsx" />;
export default LoadingContent;